export default __webpack_public_path__ + "static/media/navBar2.e45923d6.png";